import StickyTrigger from './StickyTrigger';
export default StickyTrigger;